<template>
  <h6 class="mb-0">{{ titlePage }}</h6>
  <p class="mb-0 text-sm">{{ subtitlePage }}</p>
  <hr class="my-3 horizontal dark" />
  <div class="row">
    <div class="col-4">
      <div class="form-group">
        <label for="subscriptionId" class="form-label">Subscription ID</label>
        <input id="fullName" type="text" class="form-control" disabled :value="record.id"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label for="email" class="form-label">Service Name</label>
        <input id="email" type="text" class="form-control" disabled :value="record.service_name" />
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label for="email" class="form-label">Plan</label>
        <input id="email" type="text" class="form-control" disabled :value="record.pricing_data && record.pricing_data.pricing_models[0] && record.pricing_data.pricing_models[0].label.id" />
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label class="form-label">Service Description</label>
        <input type="text" class="form-control" disabled :value="record.service_description"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Full Name</label>
        <input  type="text" class="form-control" disabled :value="record.full_name"/>
      </div>
    </div>
    <div class="col-4" v-if="record.trading_platform">
      <div class="form-group">
        <label  class="form-label">Trading Platform</label>
        <input  type="text" class="form-control" disabled :value="record.trading_platform"/>
      </div>
    </div>
    <div class="col-4" v-if="record.meta_account_number">
      <div class="form-group">
        <label  class="form-label">Meta Account Number</label>
        <input  type="text" class="form-control" disabled :value="record.meta_account_number"/>
      </div>
    </div>
    <div class="col-4" v-if="record.meta_account_master_password">
      <div class="form-group">
        <label  class="form-label">Meta Account Password Investor</label>
        <input  type="text" class="form-control" disabled :value="record.meta_account_master_password"/>
      </div>
    </div>
    <div class="col-4" v-if="record.live_server_name">
      <div class="form-group">
        <label  class="form-label">Live Server Name</label>
        <input  type="text" class="form-control" disabled :value="record.live_server_name"/>
      </div>
    </div>
    <div class="col-4"  v-if="record.margin.id == ''">
      <div class="form-group">
        <label  class="form-label">Margin In</label>
        <div class="input-group mb-3">
          <input  type="number" class="form-control" v-model="record.balance"/>

          <div class="input-group-append">
            <span class="input-group-button" id="basic-addon1">
              <button
                type="button"
                name="button"
                class="m-0 btn bg-gradient-success"
                @click="updateTradingBalance()"
                
                >
                Update
              </button>        
            </span>
          </div>        
        </div>
      </div>      
    </div>
    <div class="row" v-if="invoice != null">
      <hr />
      <label  class="form-label">Additional Data</label>

      <div class="col-4" v-if="invoice.margin.margin_in">
        <div class="form-group">
          <label class="form-label">Margin In</label>
          <input type="text" class="form-control" disabled :value="invoice.margin.margin_in"/>
        </div>
      </div>
      <div class="col-4" v-if="invoice.margin.target_profit">
        <div class="form-group">
          <label class="form-label">Target Profit</label>
          <input type="text" class="form-control" disabled :value="invoice.margin.target_profit"/>
        </div>
      </div>
      <div class="col-4" v-if="additionalData['outstanding_in']">
        <div class="form-group">
          <label class="form-label">Outstanding In %</label>
          <input type="text" class="form-control" disabled :value="additionalData['outstanding_in']"/>
        </div>
      </div>
      <div class="col-4" v-if="invoice.margin.rate">
        <div class="form-group" >
          <label class="form-label">Rate</label>
          <input type="text" class="form-control" disabled :value="invoice.margin.rate"/>
        </div>
      </div>
      <div class="col-4" v-if="invoice.margin.sas_fee">
        <div class="form-group">
          <label class="form-label">Sas Fee</label>
          <input type="text" class="form-control" disabled :value="invoice.margin.sas_fee"/>
        </div>
      </div>
      <div class="col-4" v-if="additionalData['base_price']">
        <div class="form-group">
          <label class="form-label">Base Price</label>
          <input type="text" class="form-control" disabled :value="additionalData['base_price']"/>
        </div>
      </div>

      <div class="col-4">
        <div class="form-group">
          <label class="form-label">Total Payment</label>
          <input type="text" class="form-control" disabled :value="invoice['payment_amount']"/>
        </div>
      </div>
      <hr />

    </div>



    <div class="row" v-if="invoice != null && invoice.document_service_agreement != null && invoice.status == 'paid'">
      <hr class="my-3 horizontal dark" />
      <div class="col-8">
        <div class="form-group">
          <label class="form-label mr-3">Agreement Document</label>
          <br />
          <a :href="invoice.document_service_agreement" class="btn btn-primary btn-xs" target="_blank"> Open Service Agreement </a>
          <br />
          <a :href="invoice.document_notice_of_risk" class="btn btn-primary btn-xs" target="_blank"> Open Notice Of Risk </a>
          <br />
          <a :href="invoice.document_letter_of_statement" class="btn btn-primary btn-xs" target="_blank"> Open Letter Of Statement</a>
        </div>
      </div>

    </div>
  
  </div>
  
  <!-- v-if="record.subscription_status == 'active'" -->
  <div class="row">
    <div class="col-12">
      <a :href="`/service-provider-agreement/${record.id}`" class="" data-bs-toggle="tooltip" data-bs-original-title="Service Provider Agreement" target="_blank">
        Service Provider Agreement
      </a>
    </div>
    <div class="col-12">
      <a :href="`/statement-letter/${record.id}`" class="" data-bs-toggle="tooltip" data-bs-original-title="Service Provider Agreement" target="_blank">
        Statment Letter
      </a>
    </div>
  </div>
  
  <hr class="my-3 horizontal dark" />
  <div class="form-group" v-if="record.image_signed_agreement != nil && record.image_signed_agreement != ''">
    <label class="form-label">Signed Agreement</label>
    <br />
    <a :href="record.image_signed_agreement" class="btn btn-primary btn-xs" target="_blank"> Open </a>
  </div>
  
  <div class="mt-4 d-flex justify-content-end">
    <a @click.prevent="$emit('cancel')" class="m-0 btn btn-light">
      Cancel
    </a>
    <button
    type="button"
    name="button"
    class="m-0 btn bg-gradient-success ms-2"
    @click="confirmationApprove()"
    
    >
    Approve
  </button>
  <button
    type="button"
    name="button"
    class="m-0 btn bg-gradient-danger ms-2"
    @click="confirmationReject()"
    
    >
    Reject
  </button>
</div>
</template>

<script>
import showPopupReject from "@/mixins/showSwal.js";
import showPopupApprove from "@/mixins/showSwal.js";


export default {
  data() {
    return {
      statuses: ['active', 'waiting_confirmation', 'declined'],
      record: {margin: {}},
      invoice: null,
      additionalData: {},
    };
  },
  props: {
    titlePage: String,
    subtitlePage: String,
    submitButtonName: String,
    onSubmit: { type: Function },
    toggleModal: { type: Function },
    recordProps: { type: Object },
    invoiceProps: { type: Object }
  },
  watch: {
    recordProps: function (newVal, oldVal) { // watch it
      console.log('record Prop changed: ', newVal, ' | was: ', oldVal)
      this.record = newVal
    },
    invoiceProps: function (newVal, oldVal) { // watch it
      console.log('invoice Prop changed: ', newVal, ' | was: ', oldVal)
      this.invoice = newVal
      
      if(newVal != null && newVal != undefined) {
        this.additionalData = JSON.parse(this.invoice.additional_param)
        console.log(this.additionalData)
      }
    }
  },
  mixins: [showPopupReject, showPopupApprove],
  methods: {
    confirmationReject(){
      this.showPopupReject().then((result) => {
          if (result.value) {
            const params = {
              subscription_status: 'declined'
            }
            this.onSubmit(params)
          }
        });        
    },
    confirmationApprove(){
      this.showPopupApprove().then((result) => {
          if (result.value) {
            const params = {
              subscription_status: 'active'
            }
            this.onSubmit(params)
          }
        });        
    },
    updateTradingBalance(){
      const params = {
        balance: this.record.balance
      }
      console.log(params)
      this.onSubmit(params)
    }
  }
}
</script>
